import { render, staticRenderFns } from "./SignatureRecipientsIndex.vue?vue&type=template&id=07c64382&"
import script from "./SignatureRecipientsIndex.vue?vue&type=script&lang=js&"
export * from "./SignatureRecipientsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports